import templateUrl from "emun.invoice/credit-request/credit-request-details-lines.htm";

export default () => ({ templateUrl });
